import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import Meta               from 'app/components/common/meta';
import Builder            from 'app/components/company-admin/grant-system/builder-program-app-flow';
import CadminLayout       from 'app/components/company-admin/layout/';
import ProgramAppForm     from 'app/components/grant-system/program-app-form';
import PageLoading        from 'app/components/layout/page-loading';
import GrantSysDuck       from 'app/ducks/company-admin/grant-system';
import CadminSlx          from 'app/selectors/company-admin/';

class CadminPageGrantEditApp extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      step: null,
    };

    this.refBuilder = React.createRef();
    this.refAppForm = React.createRef();

    this.onPreviewChangeStep = this.onPreviewChangeStep.bind(this);
    this.onBuilderChangeStep = this.onBuilderChangeStep.bind(this);
    this.onSortForms = this.onSortForms.bind(this);
    this.onClickAddForm = this.onClickAddForm.bind(this);
  }

  onPreviewChangeStep(step) {
    this.setState({step});
  }

  onSortForms(forms) {
    const builder = this.refBuilder.current;
    builder?.onSortForms && builder.onSortForms(forms);
  }

  onClickAddForm() {
    const builder = this.refBuilder.current;
    builder?.onClickAddForm && builder.onClickAddForm();
  }

  onBuilderChangeStep(step) {
    const appFormComp = this.refAppForm.current;
    if (appFormComp) {
      appFormComp.currentStep = step;
    }
  }

  render() {
    const {company, program} = this.props;
    if (!company) return <PageLoading />;

    const builder = program
      ? <Builder program={program} step={this.state.step} onChangeStep={this.onBuilderChangeStep} ref={this.refBuilder} />
      : null;

    return (
      <CadminLayout company={company} activeItem="grant-programs" builder={builder} dnd>
        <Meta title={`Edit Application Flow | Millie`} />
        <ProgramAppForm program={program} editMode onChangeStep={this.onPreviewChangeStep} onSortForms={this.onSortForms} onClickAddForm={this.onClickAddForm} ref={this.refAppForm} />
      </CadminLayout>
    );
  }

}

const stateToProps = (state) => ({
  company: CadminSlx.company(state),
  program: GrantSysDuck.Slx.bldrAppProg(state),
});
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(CadminPageGrantEditApp);
